{
  "name": "exa-js",
  "version": "2.0.7",
  "description": "Exa SDK for Node.js and the browser",
  "publishConfig": {
    "access": "public"
  },
  "files": [
    "dist"
  ],
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "require": "./dist/index.js",
      "module": "./dist/index.mjs",
      "import": "./dist/index.mjs"
    },
    "./package.json": "./package.json"
  },
  "types": "./dist/index.d.ts",
  "scripts": {
    "build-fast": "tsup src/index.ts --format cjs,esm",
    "build": "tsup",
    "test": "vitest run",
    "test:unit": "vitest run --config vitest.unit.config.ts",
    "test:integration": "vitest run --config vitest.integration.config.ts",
    "typecheck": "tsc --noEmit",
    "typecheck:examples": "tsc --noEmit examples/**/*.ts",
    "generate:types:websets": "openapi-typescript https://raw.githubusercontent.com/exa-labs/openapi-spec/refs/heads/master/exa-websets-spec.yaml  --enum --root-types --alphabetize --root-types-no-schema-prefix --output ./src/websets/openapi.ts && npm run format:websets",
    "format": "prettier --write \"src/**/*.ts\" \"examples/**/*.ts\"",
    "format:websets": "prettier --write src/websets/openapi.ts",
    "build:beta": "cross-env NPM_CONFIG_TAG=beta npm run build",
    "version:beta": "npm version prerelease --preid=beta",
    "version:stable": "npm version patch",
    "publish:beta": "npm run version:beta && npm run build:beta && npm publish --tag beta",
    "publish:stable": "npm run version:stable && npm run build && npm publish",
    "prepublishOnly": "npm run build"
  },
  "license": "MIT",
  "devDependencies": {
    "@types/node": "~22.14.0",
    "cross-env": "~7.0.3",
    "openapi-typescript": "~7.6.1",
    "prettier": "~3.5.3",
    "ts-node": "~10.9.2",
    "tsup": "~8.4.0",
    "typescript": "~5.8.3",
    "vitest": "~3.1.1"
  },
  "dependencies": {
    "cross-fetch": "~4.1.0",
    "dotenv": "~16.4.7",
    "openai": "^5.0.1",
    "zod": "^3.22.0",
    "zod-to-json-schema": "^3.20.0"
  },
  "directories": {
    "test": "test"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/exa-labs/exa-js.git"
  },
  "keywords": [
    "exa",
    "metaphor",
    "search",
    "AI",
    "LLMs",
    "RAG",
    "retrieval",
    "augmented",
    "generation"
  ],
  "author": "jeffzwang",
  "bugs": {
    "url": "https://github.com/exa-labs/exa-js/issues"
  },
  "homepage": "https://github.com/exa-labs/exa-js#readme"
}
